var _defs, _line, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeamwork(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_100",
    "data-name": "Group 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 88.575,
    height: 89.176,
    viewBox: "0 0 88.575 89.176",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_109",
    "data-name": "Rectangle 109",
    width: 115.705,
    height: 89.176,
    fill: "none"
  })))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_10",
    "data-name": "Line 10",
    x1: 0.513,
    y1: 0.51,
    transform: "translate(55.686 30.293)",
    fill: "none",
    stroke: "#151515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_99",
    "data-name": "Group 99"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_98",
    "data-name": "Group 98",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1479",
    "data-name": "Path 1479",
    d: "M60.368,31.391c.057.05.12.087.174.142l2.7,2.69",
    transform: "translate(-7.559 -3.931)",
    fill: "none",
    stroke: "#151515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11",
    "data-name": "Line 11",
    x2: 0.025,
    y2: 0.025,
    transform: "translate(56.199 30.803)",
    fill: "none",
    stroke: "#151515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1480",
    "data-name": "Path 1480",
    d: "M36.983,66.739h0l.013.013",
    transform: "translate(-4.631 -8.357)",
    fill: "none",
    stroke: "#151515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_12",
    "data-name": "Line 12",
    x1: 0.529,
    y1: 0.521,
    transform: "translate(32.366 58.396)",
    fill: "none",
    stroke: "#151515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1481",
    "data-name": "Path 1481",
    d: "M67.108,38.062,77.69,48.592c.157.157.295.327.444.489",
    transform: "translate(-8.403 -4.766)",
    fill: "none",
    stroke: "#151515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_13",
    "data-name": "Line 13",
    x1: 2.872,
    y1: 2.832,
    transform: "translate(32.895 58.917)",
    fill: "none",
    stroke: "#151515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1482",
    "data-name": "Path 1482",
    d: "M40.886,70.587l3.991,3.934,2.172,2.161A14.5,14.5,0,0,0,49.7,78.761",
    transform: "translate(-5.119 -8.838)",
    fill: "none",
    stroke: "#151515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1483",
    "data-name": "Path 1483",
    d: "M32.568,62.339,21.986,51.809c-.157-.157-.3-.327-.445-.489",
    transform: "translate(-2.697 -6.426)",
    fill: "none",
    stroke: "#151515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_14",
    "data-name": "Line 14",
    x2: 2.482,
    y2: 2.47,
    transform: "translate(29.87 55.913)",
    fill: "none",
    stroke: "#151515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1484",
    "data-name": "Path 1484",
    d: "M20.242,49.154a14.79,14.79,0,0,1-3.924-10.008l-5.149-5.124",
    transform: "translate(-1.399 -4.26)",
    fill: "none",
    stroke: "#151515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_15",
    "data-name": "Line 15",
    x2: 0.014,
    y2: 0.014,
    transform: "translate(32.352 58.382)",
    fill: "none",
    stroke: "#151515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1485",
    "data-name": "Path 1485",
    d: "M37.6,67.35l2.7,2.69c.054.054.118.092.175.142",
    transform: "translate(-4.708 -8.433)",
    fill: "none",
    stroke: "#151515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_16",
    "data-name": "Line 16",
    x1: 0.523,
    y1: 0.52,
    transform: "translate(32.366 58.396)",
    fill: "none",
    stroke: "#151515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1486",
    "data-name": "Path 1486",
    d: "M32.36,15.279l4.119,4.1,2.312-.255A14.616,14.616,0,0,1,48.049,21.2",
    transform: "translate(-4.052 -1.913)",
    fill: "none",
    stroke: "#151515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_17",
    "data-name": "Line 17",
    x2: 0.518,
    y2: 0.511,
    transform: "translate(55.681 30.292)",
    fill: "none",
    stroke: "#151515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_18",
    "data-name": "Line 18",
    x1: 2.872,
    y1: 2.831,
    transform: "translate(52.809 27.461)",
    fill: "none",
    stroke: "#151515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1487",
    "data-name": "Path 1487",
    d: "M50.294,22.047a14.526,14.526,0,0,1,2.649,2.078l2.171,2.162,3.992,3.934",
    transform: "translate(-6.297 -2.761)",
    fill: "none",
    stroke: "#151515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1488",
    "data-name": "Path 1488",
    d: "M67.282,38.236l-3.015-3-.024-.024",
    transform: "translate(-8.044 -4.409)",
    fill: "none",
    stroke: "#151515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1489",
    "data-name": "Path 1489",
    d: "M1.75,29.337l6.179,6.149,2.059-2.05",
    transform: "translate(-0.219 -3.673)",
    fill: "none",
    stroke: "#151515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1490",
    "data-name": "Path 1490",
    d: "M11.168,30.355,30.736,10.884,24.557,4.736",
    transform: "translate(-1.398 -0.593)",
    fill: "none",
    stroke: "#151515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1491",
    "data-name": "Path 1491",
    d: "M85.663,32.812l-4.119,4.1.256,2.3a14.431,14.431,0,0,1-2.087,9.212",
    transform: "translate(-9.981 -4.109)",
    fill: "none",
    stroke: "#151515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1492",
    "data-name": "Path 1492",
    d: "M65.5,11.726,60.352,16.85a14.946,14.946,0,0,0-10.058,3.905",
    transform: "translate(-6.297 -1.468)",
    fill: "none",
    stroke: "#151515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1493",
    "data-name": "Path 1493",
    d: "M37.6,67.35H37.6",
    transform: "translate(-4.708 -8.433)",
    fill: "none",
    stroke: "#151515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1494",
    "data-name": "Path 1494",
    d: "M67.384,10.477l-2.06-2.05,6.711-6.678",
    transform: "translate(-8.179 -0.219)",
    fill: "none",
    stroke: "#151515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1495",
    "data-name": "Path 1495",
    d: "M67.678,11.726,87.246,31.2l6.711-6.678",
    transform: "translate(-8.474 -1.468)",
    fill: "none",
    stroke: "#151515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1496",
    "data-name": "Path 1496",
    d: "M63.651,34.628h.005",
    transform: "translate(-7.97 -4.336)",
    fill: "none",
    stroke: "#151515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1497",
    "data-name": "Path 1497",
    d: "M14.739,66.931l4.119-4.1-.256-2.3a14.425,14.425,0,0,1,2.087-9.212",
    transform: "translate(-1.846 -6.426)",
    fill: "none",
    stroke: "#151515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1498",
    "data-name": "Path 1498",
    d: "M48.782,79.931a14.946,14.946,0,0,1-10.057,3.905l-5.15,5.124",
    transform: "translate(-4.204 -10.008)",
    fill: "none",
    stroke: "#151515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1499",
    "data-name": "Path 1499",
    d: "M29.819,87.465,10.252,67.994,3.573,74.639",
    transform: "translate(-0.447 -8.514)",
    fill: "none",
    stroke: "#151515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1500",
    "data-name": "Path 1500",
    d: "M32.915,90.252l2.06,2.05L28.3,98.945",
    transform: "translate(-3.543 -11.301)",
    fill: "none",
    stroke: "#151515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1501",
    "data-name": "Path 1501",
    d: "M82.635,63.252l-5.149-5.124a14.808,14.808,0,0,0-4.37-10.5l-16.3-16.225a3.545,3.545,0,0,0-5,0l-.065.065a3.609,3.609,0,0,0-.017,5.132l9.273,9.226L47.029,31.919a3.546,3.546,0,0,0-5,0l-.065.064a3.606,3.606,0,0,0-.021,5.129C46.092,41.236,53.8,48.905,53.8,48.905L39.9,35.07a3.654,3.654,0,0,0-5.149,0,3.611,3.611,0,0,0,0,5.124l13.9,13.835L36.73,42.167a3.547,3.547,0,0,0-5,0l-.064.065a3.61,3.61,0,0,0-.016,5.134L49.68,65.3l-7.56-7.522a3.887,3.887,0,0,0-5.478,0l-.469.466a2.772,2.772,0,0,0,.01,3.943l7.405,7.3,2.172,2.162A14.611,14.611,0,0,0,57.666,75.8l2.312-.256,4.119,4.1",
    transform: "translate(-3.83 -3.804)",
    fill: "none",
    stroke: "#151515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1502",
    "data-name": "Path 1502",
    d: "M73.9,93.283l-6.179-6.149,21.627-21.52,6.179,6.149",
    transform: "translate(-8.479 -8.216)",
    fill: "none",
    stroke: "#151515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamwork);
export default __webpack_public_path__ + "static/media/teamwork.1f268800a4beec1b71ec8e7e8450f0bd.svg";
export { ForwardRef as ReactComponent };